/**
 * Turning an `ApiError` into a message a person can act on.
 *
 * docs/08-frontend-and-ux.md §8: dispatch on the problem `code`, never on the
 * server's English `detail`; unknown codes fall back to one generic sentence.
 */

import type { TFunction } from 'i18next';
import { ApiError } from '../api/client.js';

export function problemMessage(error: unknown, t: TFunction): string {
  if (!(error instanceof ApiError)) return t('errors.generic');
  if (error.problem.status === 0) return t('errors.offline');

  const key = `errors.${error.problem.code}`;
  const translated = t(key);
  return translated === key ? t('errors.generic') : translated;
}

/** Field-level messages from `validation_failed`, keyed by field path. */
export function fieldErrors(error: unknown): Record<string, string> {
  if (!(error instanceof ApiError) || !error.problem.errors) return {};
  return Object.fromEntries(error.problem.errors.map((e) => [e.field, e.message]));
}
